import { TimeEntryTaskData } from './time-entry-task-data';
import { TimesheetPeriodData } from './timesheet-period-data';

/* Copyright CADS
 *
 * All rights are reserved. Reproduction or transmission in whole or in part, in
 * any form or by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 *
 * THIS FILE IS AUTO GENERATED DO NOT EDIT IT MANULLY
 *
 */

export class TimesheetData {
  TimesheetId: string;
  ContractId: string;
  ItemId: string;
  Task: TimeEntryTaskData;
  TimesheetPeriods: TimesheetPeriodData[];
}


